import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";

import { view as Header } from "../components/header";
import { view as Overview } from "./overview";
import { view as Topo } from "./topo";
import styles from "./home.module.css";

import Profile from "./profile/view";
import { view as Skills } from "./assessmentProfile/skills";
import { view as Workshops } from "./assessmentProfile/workshops";
import { view as Certifications } from "./assessmentProfile/certifications";
import { view as Conferences } from "./assessmentProfile/conferences";
import { view as Internships } from "./assessmentProfile/internships";
import { view as Publications } from "./assessmentProfile/publications";
import { view as UserProfile } from "./userprofile";
import { view as Projects } from "./projects";

import ProjectDashboard from "./assessmentProfile/projectsDashboard/view";
import { view as StudentList } from "./topo/studentList";
import { view as FacultyList } from "./topo/facultyList";

import VedicLogo from "../components/images/vedic_logo.png";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { view as cpDashboard } from "./cpDashboard";
import { view as CPTeam } from "./cpTeams";
import { view as CPTeamsView } from "./cpTeamsView";
import { Result, Button, Row, Col, Spin, Icon, Layout } from "antd";
import { view as addHOD } from "./admin/addHOD";
import AddFaculty from "./admin/addFaculty/view";
import { view as SkillDashboard } from "./assessmentProfile/skillsDashboard";
// import { view as addFaculty } from "./admin/addFaculty";
import { view as addStudent } from "./admin/addStudent";
import { view as addAdmin } from "./admin/addAdmin";
import { view as addPrincipal } from "./admin/addPrincipal";
import { isMobileOnly, isMobile } from "react-device-detect";
const queryString = require('query-string');
const addFaculty = AddFaculty;
const { Content, Footer } = Layout;
const PageNotFound = (history, profile) => () => {
  return (
    <Row
      type="flex"
      justify="space-around"
      align="middle"
      style={{
        backgroundSize: "cover",
        backgroundColor: "#039BE5",
        backgroundRepeat: "no-repeat",
        height: "100%"
      }}
    >
      <Col xs={24} sm={24} md={24} lg={10} xl={10} style={{ padding: 100 }}>
        <div
          style={{
            padding: "25px",
            textAlign: "center"
          }}
        >
          <img style={{ marginBottom: 20 }} src={VedicLogo}></img>
          <Result
            status="404"
            title="404"
            subTitle="Sorry, the page you visited does not exist."
            style={{ color: "white", fontSize: "50px" }}
            extra={
              <Button
                style={{ background: "#001529" }}
                type="primary"
                onClick={() => history.replace("/")}
              >
                Go Home
              </Button>
            }
          />
        </div>
      </Col>
    </Row>
  );
};

class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: true
    };
  }

  componentWillUnmount() {
    this.props.onUnload();
  }

  
  setCollapsed = () => {
    this.setState({
      collapsed: !this.state.collapsed
    });
  };

  render() {
    const { auth, profile } = this.props;
    console.log("auth",auth)
    const parsed = queryString.parse(this.props.location.search);
    

    //   if (isMobileOnly) {
    //     return <div style={{textAlign:'center',marginTop:20,padding:20}}> Unfortunately, this webiste not available in mobile. Please revisit the site in laptop/desktop. If any problem, please contact admin@vedic.dev </div>
    // }

    if (auth && !auth.uid) {
      return <Redirect to="/login" />;
    } else if (profile && !profile.isLoaded) {
      return (
        <div className={styles["loader-wrapper"]}>
          <div className={styles["loader-content"]}>
            <Spin
              indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />}
            />
          </div>
        </div>
      );
    } else if (profile.role == "ADMIN") {
      return (
        <Layout>
        <Header collapsed={false} setCollapsed={this.setCollapsed} />
        <div style={{fontSize:'18px',textAlign:'center', background:'#726a7d',color:'white',paddingTop:'20px',paddingBottom:'20px',fontWeight:'600' ,marginTop: isMobile ? 0 : 67}}>
         <a target="_blank" href={"https://us-central1-vedic-lms.cloudfunctions.net/redirectToLMS/redirect?idToken="+(auth&&auth.stsTokenManager.accessToken)} style={{color:'white'}}>Click to access  <u>SVES Learning Platfrom</u></a> 
          </div>
        <Content style={{ marginTop: isMobile ? 0 : 0 }}>
              <Switch>
                <Route
                  path="/home/profile/:uid"
                  render={props => (
                    <Profile key={props.match.params.uid} {...props} />
                  )}
                />

                <Route
                  path="/home/projects"
                  render={props => <Projects {...props} />}
                />

                {/* Teams */}
                <Route
                  path="/home/cpTeamsView"
                  render={props => <CPTeamsView {...props} />}
                />
                <Route
                  path="/home/cpTeams"
                  render={props => <CPTeam {...props} />}
                />

                {/* CompetetivePrgrammingDashboard */}
                <Route path="/home/cpDashboard" component={cpDashboard} />

                {/* AdminSection */}

                <Route path="/home/addHOD" component={addHOD} />
                <Route path="/home/addFaculty" component={addFaculty} />
                <Route path="/home/addStudent" component={addStudent} />
                <Route path="/home/addPrincipal" component={addPrincipal} />
                <Route path="/home/addAdmin" component={addAdmin} />

                {/* DasboardRoutes */}

                <Route
                path="/home/studentsList"
                render={props => (
                  <StudentList
                  key={"studentList"+(parsed&&parsed.Category&&parsed.Category)}
                    {...props}
                  />
                )}
              />
              <Route
                path="/home/facultyList"
                render={props => (
                  <FacultyList
                    key={"facultyList"+(parsed&&parsed.Category&&parsed.Category)}
                    {...props}
                  />
                )}
              />

              <Route
                path="/home/campusDashboard/:campusName"
                render={props => (
                  <Topo key={props.match.params.campusName+(parsed&&parsed.Category&&parsed.Category)} {...props} />
                )}
              />

              <Route
                path="/home/skills/:skillName"
                render={props => (
                  <Skills
                    key={props.match.params.skillName}
                    key={"skills"+props.match.params.skillName+(parsed&&parsed.Category&&parsed.Category)}
                    {...props}
                  />
                )}
              />

              <Route
                path="/home/skills"
                
                render={props => (
                  <SkillDashboard
                    key={"skills"+(parsed&&parsed.Category&&parsed.Category)}
                    {...props}
                  />
                )}
              />

              <Route
                path="/home/workshops"
                render={props => (
                  <Workshops
                  key={"workshops"+(parsed&&parsed.Category&&parsed.Category)}
                    {...props}
                  />
                )}
              />
              <Route
                path="/home/internships"
                render={props => (
                  <Internships
                  key={"internships"+(parsed&&parsed.Category&&parsed.Category)}
                    {...props}
                  />
                )}
              />
              <Route
                path="/home/publications"
                render={props => (
                  <Publications
                  key={"publications"+(parsed&&parsed.Category&&parsed.Category)}
                    {...props}
                  />
                )}
              />
              <Route
                path="/home/certifications"
                render={props => (
                  <Certifications
                  key={"certifications"+(parsed&&parsed.Category&&parsed.Category)}
                    {...props}
                  />
                )}
              />
              <Route
                path="/home/conferences"
                render={props => (
                  <Conferences
                  key={"conferences"+(parsed&&parsed.Category&&parsed.Category)}
                    {...props}
                  />
                )}
              />

              <Route
                path="/home/projectsDashboard"
                render={props => (
                  <ProjectDashboard
                  key={"projectDasboard"+(parsed&&parsed.Category&&parsed.Category)}
                    {...props}
                  />
                )}
              />

                {/* PageNotFound */}
                <Route component={PageNotFound(this.props.history, profile)} />
              </Switch>
              </Content>
          <Footer
            style={{
              textAlign: "center",
              background: "#d9d5de",
              marginTop: "50px"
            }}
          >
            © 2020 Vedic Assessment Platform | Powered by CODINZA @ StudyOwl
            Education Private Limited
          </Footer>
        </Layout>
      );
    } else if (profile.role == "STUDENT") {
      return (
        <Layout>
          <Header collapsed={false} setCollapsed={this.setCollapsed} />

          <div style={{fontSize:'18px',textAlign:'center', background:'#726a7d',color:'white',paddingTop:'20px',paddingBottom:'20px',fontWeight:'600' ,marginTop: isMobile ? 0 : 67}}>
         <a target="_blank" href={"https://us-central1-vedic-lms.cloudfunctions.net/redirectToLMS/redirect?idToken="+(auth&&auth.stsTokenManager.accessToken)} style={{color:'white'}}>Click to access  <u>SVES Learning Platfrom</u></a> 
          </div>


          <Content style={{ marginTop: isMobile ? 0 : 0 }}>
            <Switch>
              <Route path="/home/overview" component={Overview} />
              <Route
                path="/home/profile/:uid"
                render={props => (
                  <Profile key={props.match.params.uid} {...props} />
                )}
              />

              <Route
                path="/home/projects"
                render={props => (
                  <Projects
                    userBranch={profile.branch}
                    userCampus={profile.campus}
                    {...props}
                  />
                )}
              />

              {/* Teams */}
              <Route
                path="/home/cpTeamsView"
                render={props => <CPTeamsView {...props} />}
              />

              {/* CompetetivePrgrammingDashboard */}
              <Route path="/home/cpDashboard" component={cpDashboard} />

              {/* DasboardRoutes */}

              <Route
                path="/home/studentsList"
                render={props => (
                  <StudentList
                  key={"studentList"+(parsed&&parsed.Category&&parsed.Category)}
                  userCampus={profile.campus}
                    {...props}
                  />
                )}
              />
              <Route
                path="/home/facultyList"
                render={props => (
                  <FacultyList
                    key={"facultyList"+(parsed&&parsed.Category&&parsed.Category)}
                    userCampus={profile.campus}
                    {...props}
                  />
                )}
              />

              <Route
                path="/home/campusDashboard/:campusName"
                render={props => (
                  <Topo key={props.match.params.campusName+(parsed&&parsed.Category&&parsed.Category)} {...props} />
                )}
              />

              <Route
                path="/home/skills/:skillName"
                render={props => (
                  <Skills
                    key={props.match.params.skillName}
                    key={"skills"+props.match.params.skillName+(parsed&&parsed.Category&&parsed.Category)}
                    userCampus={profile.campus}
                    {...props}
                  />
                )}
              />

              <Route
                path="/home/skills"
                
                render={props => (
                  <SkillDashboard
                    key={"skills"+(parsed&&parsed.Category&&parsed.Category)}
                    userCampus={profile.campus}
                    {...props}
                  />
                )}
              />

              <Route
                path="/home/workshops"
                render={props => (
                  <Workshops
                  key={"workshops"+(parsed&&parsed.Category&&parsed.Category)}
                  userCampus={profile.campus}
                    {...props}
                  />
                )}
              />
              <Route
                path="/home/internships"
                render={props => (
                  <Internships
                  key={"internships"+(parsed&&parsed.Category&&parsed.Category)}
                  userCampus={profile.campus}
                    {...props}
                  />
                )}
              />
              <Route
                path="/home/publications"
                render={props => (
                  <Publications
                  key={"publications"+(parsed&&parsed.Category&&parsed.Category)}
                  userCampus={profile.campus}
                    {...props}
                  />
                )}
              />
              <Route
                path="/home/certifications"
                render={props => (
                  <Certifications
                  key={"certifications"+(parsed&&parsed.Category&&parsed.Category)}
                  userCampus={profile.campus}
                    {...props}
                  />
                )}
              />
              <Route
                path="/home/conferences"
                render={props => (
                  <Conferences
                  key={"conferences"+(parsed&&parsed.Category&&parsed.Category)}
                  userCampus={profile.campus}
                    {...props}
                  />
                )}
              />

              <Route
                path="/home/projectsDashboard"
                render={props => (
                  <ProjectDashboard
                  key={"projectDasboard"+(parsed&&parsed.Category&&parsed.Category)}
                  userCampus={profile.campus}
                    {...props}
                  />
                )}
              />

              {/* PageNotFound */}
              <Route component={PageNotFound(this.props.history, profile)} />


              
            </Switch>
          </Content>
          <Footer
            style={{
              textAlign: "center",
              background: "#d9d5de",
              marginTop: "50px"
            }}
          >
            © 2020 Vedic Assessment Platform | Powered by CODINZA @ StudyOwl
            Education Private Limited
          </Footer>
        </Layout>
      );

      //       return <div className="ant-layout ant-layout-has-sider">
      //         <div className={`${styles["content-wrapper"]} ant-layout`}>
      //           <div>
      //             <Header collapsed={false} setCollapsed={this.setCollapsed} />
      //           </div>
      //           <div className={`${styles.content} ant-layout-content`}>

      //           </div></div></div>
    } else if (profile.role == "FACULTY") {
      return (
        <Layout>
        <Header collapsed={false} setCollapsed={this.setCollapsed} />
        
        <div style={{fontSize:'18px',textAlign:'center', background:'#726a7d',color:'white',paddingTop:'20px',paddingBottom:'20px',fontWeight:'600' ,marginTop: isMobile ? 0 : 67}}>
         <a target="_blank" href={"https://us-central1-vedic-lms.cloudfunctions.net/redirectToLMS/redirect?idToken="+(auth&&auth.stsTokenManager.accessToken)} style={{color:'white'}}>Click to access  <u>SVES Learning Platfrom</u></a> 
          </div>
        <Content style={{ marginTop: isMobile ? 0 : 0 }}>
              <Switch>
                <Route path="/home/overview" component={Overview} />
                <Route
                  path="/home/profile/:uid"
                  render={props => (
                    <Profile key={props.match.params.uid} {...props} />
                  )}
                />

                <Route
                  path="/home/projects"
                  render={props => (
                    <Projects
                      userBranch={profile.branch}
                      userCampus={profile.campus}
                      {...props}
                    />
                  )}
                />

                {/* Teams */}
                <Route
                  path="/home/cpTeamsView"
                  render={props => <CPTeamsView {...props} />}
                />
                <Route
                  path="/home/cpTeams"
                  render={props => (
                    <CPTeam
                      userBranch={profile.branch}
                      userCampus={profile.campus}
                      {...props}
                    />
                  )}
                />

                {/* CompetetivePrgrammingDashboard */}
                <Route path="/home/cpDashboard" component={cpDashboard} />

                {/* AdminSection */}

                <Route path="/home/addStudent" component={addStudent} />

                {/* DasboardRoutes */}

                <Route
                path="/home/studentsList"
                render={props => (
                  <StudentList
                  key={"studentList"+(parsed&&parsed.Category&&parsed.Category)}
                  userCampus={profile.campus}
                    {...props}
                  />
                )}
              />
              <Route
                path="/home/facultyList"
                render={props => (
                  <FacultyList
                    key={"facultyList"+(parsed&&parsed.Category&&parsed.Category)}
                    userCampus={profile.campus}
                    {...props}
                  />
                )}
              />

              <Route
                path="/home/campusDashboard/:campusName"
                render={props => (
                  <Topo key={props.match.params.campusName+(parsed&&parsed.Category&&parsed.Category)} {...props} />
                )}
              />

              <Route
                path="/home/skills/:skillName"
                render={props => (
                  <Skills
                    key={props.match.params.skillName}
                    key={"skills"+props.match.params.skillName+(parsed&&parsed.Category&&parsed.Category)}
                    userCampus={profile.campus}
                    {...props}
                  />
                )}
              />

              <Route
                path="/home/skills"
                
                render={props => (
                  <SkillDashboard
                    key={"skills"+(parsed&&parsed.Category&&parsed.Category)}
                    userCampus={profile.campus}
                    {...props}
                  />
                )}
              />

              <Route
                path="/home/workshops"
                render={props => (
                  <Workshops
                  key={"workshops"+(parsed&&parsed.Category&&parsed.Category)}
                  userCampus={profile.campus}
                    {...props}
                  />
                )}
              />
              <Route
                path="/home/internships"
                render={props => (
                  <Internships
                  key={"internships"+(parsed&&parsed.Category&&parsed.Category)}
                  userCampus={profile.campus}
                    {...props}
                  />
                )}
              />
              <Route
                path="/home/publications"
                render={props => (
                  <Publications
                  key={"publications"+(parsed&&parsed.Category&&parsed.Category)}
                  userCampus={profile.campus}
                    {...props}
                  />
                )}
              />
              <Route
                path="/home/certifications"
                render={props => (
                  <Certifications
                  key={"certifications"+(parsed&&parsed.Category&&parsed.Category)}
                  userCampus={profile.campus}
                    {...props}
                  />
                )}
              />
              <Route
                path="/home/conferences"
                render={props => (
                  <Conferences
                  key={"conferences"+(parsed&&parsed.Category&&parsed.Category)}
                  userCampus={profile.campus}
                    {...props}
                  />
                )}
              />

              <Route
                path="/home/projectsDashboard"
                render={props => (
                  <ProjectDashboard
                  key={"projectDasboard"+(parsed&&parsed.Category&&parsed.Category)}
                  userCampus={profile.campus}
                    {...props}
                  />
                )}
              />
                {/* PageNotFound */}
                <Route component={PageNotFound(this.props.history, profile)} />
              </Switch>
              </Content>
          <Footer
            style={{
              textAlign: "center",
              background: "#d9d5de",
              marginTop: "50px"
            }}
          >
            © 2020 Vedic Assessment Platform | Powered by CODINZA @ StudyOwl
            Education Private Limited
          </Footer>
        </Layout>
      );
    } else if (profile.role == "HOD") {
      return (
        <Layout>
        <Header collapsed={false} setCollapsed={this.setCollapsed} />
        
        <div style={{fontSize:'18px',textAlign:'center', background:'#726a7d',color:'white',paddingTop:'20px',paddingBottom:'20px',fontWeight:'600' ,marginTop: isMobile ? 0 : 67}}>
         <a target="_blank" href={"https://us-central1-vedic-lms.cloudfunctions.net/redirectToLMS/redirect?idToken="+(auth&&auth.stsTokenManager.accessToken)} style={{color:'white'}}>Click to access  <u>SVES Learning Platfrom</u></a> 
          </div>
        <Content style={{ marginTop: isMobile ? 0 : 0 }}>
              <Switch>
                <Route path="/home/overview" component={Overview} />
                <Route
                  path="/home/profile/:uid"
                  render={props => (
                    <Profile key={props.match.params.uid} {...props} />
                  )}
                />

                <Route
                  path="/home/projects"
                  render={props => (
                    <Projects
                      userBranch={profile.branch}
                      userCampus={profile.campus}
                      {...props}
                    />
                  )}
                />

                {/* Teams */}
                <Route
                  path="/home/cpTeamsView"
                  render={props => <CPTeamsView {...props} />}
                />
                <Route
                  path="/home/cpTeams"
                  render={props => (
                    <CPTeam
                      userBranch={profile.branch}
                      userCampus={profile.campus}
                      {...props}
                    />
                  )}
                />

                {/* CompetetivePrgrammingDashboard */}
                <Route path="/home/cpDashboard" component={cpDashboard} />

                {/* AdminSection */}

                <Route path="/home/addFaculty" component={addFaculty} />
                <Route path="/home/addStudent" component={addStudent} />

                {/* DasboardRoutes */}

                <Route
                path="/home/studentsList"
                render={props => (
                  <StudentList
                  key={"studentList"+(parsed&&parsed.Category&&parsed.Category)}
                  userCampus={profile.campus}
                    {...props}
                  />
                )}
              />
              <Route
                path="/home/facultyList"
                render={props => (
                  <FacultyList
                    key={"facultyList"+(parsed&&parsed.Category&&parsed.Category)}
                    userCampus={profile.campus}
                    {...props}
                  />
                )}
              />

              <Route
                path="/home/campusDashboard/:campusName"
                render={props => (
                  <Topo key={props.match.params.campusName+(parsed&&parsed.Category&&parsed.Category)} {...props} />
                )}
              />

              <Route
                path="/home/skills/:skillName"
                render={props => (
                  <Skills
                    key={props.match.params.skillName}
                    key={"skills"+props.match.params.skillName+(parsed&&parsed.Category&&parsed.Category)}
                    userCampus={profile.campus}
                    {...props}
                  />
                )}
              />

              <Route
                path="/home/skills"
                
                render={props => (
                  <SkillDashboard
                    key={"skills"+(parsed&&parsed.Category&&parsed.Category)}
                    userCampus={profile.campus}
                    {...props}
                  />
                )}
              />

              <Route
                path="/home/workshops"
                render={props => (
                  <Workshops
                  key={"workshops"+(parsed&&parsed.Category&&parsed.Category)}
                  userCampus={profile.campus}
                    {...props}
                  />
                )}
              />
              <Route
                path="/home/internships"
                render={props => (
                  <Internships
                  key={"internships"+(parsed&&parsed.Category&&parsed.Category)}
                  userCampus={profile.campus}
                    {...props}
                  />
                )}
              />
              <Route
                path="/home/publications"
                render={props => (
                  <Publications
                  key={"publications"+(parsed&&parsed.Category&&parsed.Category)}
                  userCampus={profile.campus}
                    {...props}
                  />
                )}
              />
              <Route
                path="/home/certifications"
                render={props => (
                  <Certifications
                  key={"certifications"+(parsed&&parsed.Category&&parsed.Category)}
                  userCampus={profile.campus}
                    {...props}
                  />
                )}
              />
              <Route
                path="/home/conferences"
                render={props => (
                  <Conferences
                  key={"conferences"+(parsed&&parsed.Category&&parsed.Category)}
                  userCampus={profile.campus}
                    {...props}
                  />
                )}
              />

              <Route
                path="/home/projectsDashboard"
                render={props => (
                  <ProjectDashboard
                  key={"projectDasboard"+(parsed&&parsed.Category&&parsed.Category)}
                  userCampus={profile.campus}
                    {...props}
                  />
                )}
              />

                {/* PageNotFound */}
                <Route component={PageNotFound(this.props.history, profile)} />
              </Switch>
              </Content>
          <Footer
            style={{
              textAlign: "center",
              background: "#d9d5de",
              marginTop: "50px"
            }}
          >
            © 2020 Vedic Assessment Platform | Powered by CODINZA @ StudyOwl
            Education Private Limited
          </Footer>
        </Layout>
      );
    } else if (profile.role == "PRINCIPAL") {
      return (
        <Layout>
        <Header collapsed={false} setCollapsed={this.setCollapsed} />
        <div style={{fontSize:'18px',textAlign:'center', background:'#726a7d',color:'white',paddingTop:'20px',paddingBottom:'20px',fontWeight:'600' ,marginTop: isMobile ? 0 : 67}}>
         <a target="_blank" href={"https://us-central1-vedic-lms.cloudfunctions.net/redirectToLMS/redirect?idToken="+(auth&&auth.stsTokenManager.accessToken)} style={{color:'white'}}>Click to access  <u>SVES Learning Platfrom</u></a> 
          </div>
        <Content style={{ marginTop: isMobile ? 0 : 0 }}>
              <Switch>
                <Route path="/home/overview" component={Overview} />
                <Route
                  path="/home/profile/:uid"
                  render={props => (
                    <Profile key={props.match.params.uid} {...props} />
                  )}
                />

                <Route
                  path="/home/projects"
                  render={props => (
                    <Projects userCampus={profile.campus} {...props} />
                  )}
                />

                {/* Teams */}
                <Route
                  path="/home/cpTeamsView"
                  render={props => <CPTeamsView {...props} />}
                />
                <Route
                  path="/home/cpTeams"
                  render={props => (
                    <CPTeam userCampus={profile.campus} {...props} />
                  )}
                />

                {/* CompetetivePrgrammingDashboard */}
                <Route path="/home/cpDashboard" component={cpDashboard} />

                {/* AdminSection */}

                <Route path="/home/addHOD" component={addHOD} />
                <Route path="/home/addFaculty" component={addFaculty} />
                <Route path="/home/addStudent" component={addStudent} />
                <Route path="/home/addPrincipal" component={addPrincipal} />

                {/* DasboardRoutes */}

                <Route
                path="/home/studentsList"
                render={props => (
                  <StudentList
                  key={"studentList"+(parsed&&parsed.Category&&parsed.Category)}
                  userCampus={profile.campus}
                    {...props}
                  />
                )}
              />
              <Route
                path="/home/facultyList"
                render={props => (
                  <FacultyList
                    key={"facultyList"+(parsed&&parsed.Category&&parsed.Category)}
                    userCampus={profile.campus}
                    {...props}
                  />
                )}
              />

              <Route
                path="/home/campusDashboard/:campusName"
                render={props => (
                  <Topo key={props.match.params.campusName+(parsed&&parsed.Category&&parsed.Category)} {...props} />
                )}
              />

              <Route
                path="/home/skills/:skillName"
                render={props => (
                  <Skills
                    key={props.match.params.skillName}
                    key={"skills"+props.match.params.skillName+(parsed&&parsed.Category&&parsed.Category)}
                    userCampus={profile.campus}
                    {...props}
                  />
                )}
              />

              <Route
                path="/home/skills"
                
                render={props => (
                  <SkillDashboard
                    key={"skills"+(parsed&&parsed.Category&&parsed.Category)}
                    userCampus={profile.campus}
                    {...props}
                  />
                )}
              />

              <Route
                path="/home/workshops"
                render={props => (
                  <Workshops
                  key={"workshops"+(parsed&&parsed.Category&&parsed.Category)}
                  userCampus={profile.campus}
                    {...props}
                  />
                )}
              />
              <Route
                path="/home/internships"
                render={props => (
                  <Internships
                  key={"internships"+(parsed&&parsed.Category&&parsed.Category)}
                  userCampus={profile.campus}
                    {...props}
                  />
                )}
              />
              <Route
                path="/home/publications"
                render={props => (
                  <Publications
                  key={"publications"+(parsed&&parsed.Category&&parsed.Category)}
                  userCampus={profile.campus}
                    {...props}
                  />
                )}
              />
              <Route
                path="/home/certifications"
                render={props => (
                  <Certifications
                  key={"certifications"+(parsed&&parsed.Category&&parsed.Category)}
                  userCampus={profile.campus}
                    {...props}
                  />
                )}
              />
              <Route
                path="/home/conferences"
                render={props => (
                  <Conferences
                  key={"conferences"+(parsed&&parsed.Category&&parsed.Category)}
                  userCampus={profile.campus}
                    {...props}
                  />
                )}
              />

              <Route
                path="/home/projectsDashboard"
                render={props => (
                  <ProjectDashboard
                  key={"projectDasboard"+(parsed&&parsed.Category&&parsed.Category)}
                  userCampus={profile.campus}
                    {...props}
                  />
                )}
              />

                {/* PageNotFound */}
                <Route component={PageNotFound(this.props.history, profile)} />
              </Switch>
              </Content>
          <Footer
            style={{
              textAlign: "center",
              background: "#d9d5de",
              marginTop: "50px"
            }}
          >
            © 2020 Vedic Assessment Platform | Powered by CODINZA @ StudyOwl
            Education Private Limited
          </Footer>
        </Layout>
      );
    } else {
      return (
        <Result
          status="500"
          title="500"
          subTitle="Sorry, the something wrong."
          extra={<Button href="maitlto:admin@vedic.dev" type="primary">Report</Button>}
        />
      );
    }
  }
}

const mapStateToProps = state => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile
  };
};

const mapDispachToProps = (dispatch, props) => ({
  onUnload: () => dispatch({ type: "HOME_PAGE_UNLOADED" })
});

export default connect(mapStateToProps, mapDispachToProps)(HomePage);
